// packages/frontend/src/pages/admin/SportSeasonsTab.tsx
import { useEffect, useState } from 'react';
import { useSportSeasonsStore } from '../../store/sportSeasonsStore';
import { SportSeasonsMatrix } from '../../components/admin/SportSeasonsMatrix';
import { SportSeasonsBulkView } from '../../components/admin/SportSeasonsBulkView';

export function SportSeasonsTab() {
  const [view, setView] = useState<'matrix' | 'bulk'>('matrix');
  const { loadCoverage } = useSportSeasonsStore();

  useEffect(() => {
    loadCoverage();
  }, [loadCoverage]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 border-b border-gray-200 dark:border-gray-700 pb-2">
        <button
          type="button"
          onClick={() => setView('matrix')}
          className={
            view === 'matrix'
              ? 'btn-secondary !bg-blast-50 !text-blast-700 !border-blast-300 dark:!bg-blast-900/30 dark:!text-blast-200 dark:!border-blast-700'
              : 'btn-secondary'
          }
        >
          Matrix
        </button>
        <button
          type="button"
          onClick={() => setView('bulk')}
          className={
            view === 'bulk'
              ? 'btn-secondary !bg-blast-50 !text-blast-700 !border-blast-300 dark:!bg-blast-900/30 dark:!text-blast-200 dark:!border-blast-700'
              : 'btn-secondary'
          }
        >
          Import / Export
        </button>
      </div>
      {view === 'matrix' ? <SportSeasonsMatrix /> : <SportSeasonsBulkView />}
    </div>
  );
}
